import React, { useEffect, useRef } from 'react';
import { useSearchBox } from 'react-instantsearch';

export default function SearchForm({ inputValue, setInputValue, inputRef }) {
    const { refine } = useSearchBox();
    const debounceTimer = useRef(null);

    useEffect(() => {
        if (debounceTimer.current) {
            clearTimeout(debounceTimer.current);
        }

        debounceTimer.current = setTimeout(() => {
            if (inputValue && inputValue.length > 1) {
                refine(inputValue);
            } else {
                refine('');
            }
        }, 300);

        return () => {
            if (debounceTimer.current) {
                clearTimeout(debounceTimer.current);
            }
        };
    }, [inputValue]);

    return (
        <input
            ref={inputRef}
            id="header-search-input"
            type="text"
            className="form-control form-control--search search__overlay-input"
            value={inputValue}
            autoComplete="off"
            placeholder={window.Translator.trans('app.header.search.input.placeholder')}
            onChange={(event) => setInputValue(event.target.value)}
        />
    );
}
